import { aboutData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function AboutSection() {
  const ref = useScrollReveal();
  return (
    <section id="about" ref={ref} className="reveal-section py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20film%20library%20aesthetic%20with%20warm%20lighting%2C%20shelves%20of%20movie%20collection%2C%20cozy%20atmosphere%2C%20golden%20and%20amber%20tones%2C%20professional%20interior%20photography%20style%2C%20rich%20dark%20wood%20textures&width=700&height=500&seq=about-visual&orientation=landscape"
                alt="91精品影视 - 平台介绍"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              {aboutData.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              {aboutData.desc}
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-shield-check-line"></i>
                </div>
                <span>资源安全检测</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-speed-up-line"></i>
                </div>
                <span>高速下载通道</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-customer-service-2-line"></i>
                </div>
                <span>7×24小时服务</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-refresh-line"></i>
                </div>
                <span>每日资源更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}